import React from 'react';

import { isObject } from '@Sage/ssm-utils';
import {
    ReactSelectComponents,
    SelectDropdownIndicator,
    SelectLockIndicator,
} from '@Sage/hoi-poi-ui';

import PopoverHoiInfoIcon from './PopoverHoiInfoIcon';
import './styles.scss';

const CustomSelectIndicatorContainer = (props) => {
    const renderComponent = !props.isDisabled ? (
        <SelectDropdownIndicator {...props} />
    ) : (
        <SelectLockIndicator {...props} />
    );

    let content = '';

    if (props.selectProps.value && isObject(props.selectProps.value)) {
        content = props.selectProps.value.description
            ? props.selectProps.value.description
            : props.selectProps.value.label;
    }

    return (
        ReactSelectComponents.IndicatorsContainer && (
            <ReactSelectComponents.IndicatorsContainer {...props}>
                {!props.isDisabled && content && (
                    <div className="fm-select__custom-tooltip">
                        <PopoverHoiInfoIcon content={content} />
                    </div>
                )}
                {renderComponent}
            </ReactSelectComponents.IndicatorsContainer>
        )
    );
};

export default CustomSelectIndicatorContainer;
